import React, { useEffect, useState } from 'react';
import { firestore } from './firebaseConfig';
import { collection, getDocs } from 'firebase/firestore';
import Slider from 'react-slick';
import './ProgrammesOutput.css'; // Ensure to create or update this CSS file
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';

const ProgrammesOutput = () => {
  const [programmes, setProgrammes] = useState([]);
  const [selectedProgramme, setSelectedProgramme] = useState(null);

  useEffect(() => {
    const fetchProgrammes = async () => {
      const programmesCollection = collection(firestore, 'programmes');
      const programmesSnapshot = await getDocs(programmesCollection);
      setProgrammes(programmesSnapshot.docs.map((doc) => doc.data()));
    };

    fetchProgrammes();
  }, []);

  const openModal = (programme) => {
    setSelectedProgramme(programme);
  };

  const closeModal = () => {
    setSelectedProgramme(null);
  };

  // Function to truncate description
  const truncateDescription = (description, maxLength) => {
    if (description.length > maxLength) {
      return description.slice(0, maxLength) + '...'; // Add ellipsis if truncated
    }
    return description;
  };

  // Carousel settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="programmes-container">
      <h2>Our Programmes</h2>
      {programmes.length === 0 ? (
        <p>No programmes added yet.</p>
      ) : (
        <Slider {...settings} className="programmes-carousel">
          {programmes.map((programme, index) => (
            <div 
              key={index} 
              className="programme-card"
              onClick={() => openModal(programme)} 
            >
              <img 
                src={programme.imageUrls[0]} 
                alt={programme.name} 
                className="programme-image" 
              />
              <h3 className="programme-name">{programme.name}</h3>
              <p className="programme-description">
                {truncateDescription(programme.description, 100)} {/* Truncate to 100 characters */}
              </p>
              <button className="read-more-button" onClick={() => openModal(programme)}>
                Read More
              </button>
            </div>
          ))}
        </Slider>
      )}
      {selectedProgramme && (
        <Modal 
          programme={selectedProgramme} 
          onClose={closeModal} 
        />
      )}
    </div>
  );
};

// Modal Component
const Modal = ({ programme, onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>{programme.name}</h2>
        <img src={programme.imageUrls[0]} alt={programme.name} className="modal-image" />
        <p className="modal-description">{programme.description}</p>
        <button onClick={onClose} className="modal-close-button">Close</button>
      </div>
    </div>
  );
};

export default ProgrammesOutput;
